import CsChart from "./cs-chart.vue";

export default CsChart;
